import { graphql } from "react-relay";

export const VIMEO_VIMEO_VIDEO_SOURCE_FRAGMENT = graphql`
	fragment videoSourceForm_Vimeo_VimeoVideoSourceFragment on Vimeo_VimeoVideoSource {
		name
	}
`;
